export default __webpack_public_path__ + "assets/b212b1723cffb68dd1ded774fad3acad-product-default.svg";